import Toast from 'react-native-toast-message'

// tRPC surfaces internal errors verbatim ("UNAUTHORIZED", a Prisma string, a stack). None of that
// means anything to a crew member standing in a loading bay, so anything that is not one of our
// own messages gets the generic line instead.
const isPresentable = (message: string | undefined): message is string =>
  !!message && message.length < 160 && /[a-z]\s/.test(message) && !message.includes('\n')

export const showAvailabilityError = (message?: string) => {
  Toast.show({
    type: 'error',
    text1: 'Could not save',
    text2: isPresentable(message)
      ? message
      : 'Something went wrong saving this. Check your signal and try again.',
    visibilityTime: 6000,
  })
}
